import {defineCssVars} from '@chakra-ui/styled-system';

export const vars = defineCssVars(`nav`, [
  `size`,
  `button-font-weight`,
  `group-button-font-weight`,
  `height`,
  `icon-size`,
  `font-size`,
  `text-space`,
  `background`,
  `padding-horizontal`,
]);

export const itemVars = defineCssVars(`nav-item`, [`radius`, `padding`, `gap`]);

export const menuVars = defineCssVars(`nav-menu`, [`gap`]);

export const headerVars = defineCssVars(`nav-header`, [`height`, `padding`]);

export const footerVars = defineCssVars(`nav-footer`, [`padding-horizontal`, `gap`]);
